import { FindingType } from "@/common/api/findings/findings.model";

export const FindingsResultMap: {
  [key: string]: { gap: string; findings: [FindingType, string][] };
} = {
  mpip: {
    gap: "<b>{count}</b> files did not have an applicable labeling rules",
    findings: [
      [
        "pb_cloud_mip_label_applied",
        "Cognni successfully applied Microsoft Sensitivity Labels to <b>{count}</b> files",
      ],
      [
        "pb_cloud_mip_label_labeled",
        "<b>{count}</b> files already had the requested sensitivity label",
      ],
      [
        "pb_cloud_mip_label_conflict",
        "<b>{count}</b> files had higher priority sensitivity labels",
      ],
      [
        "pb_cloud_mip_label_failed",
        "<b>{count}</b> files had the sensitivity label request rejected",
      ],
    ],
  },
};
